import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import $ from 'jquery';

class AcademicPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: new Array(2).fill(false),
			dropdownOpen1: new Array(2).fill(false),
			dropdownOpen2: new Array(2).fill(false),
			dropdownOpen3: new Array(2).fill(false),
			dropdownOpen4: new Array(2).fill(false),
			dropdownOpen5: new Array(2).fill(false),
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.toggle4 = this.toggle4.bind(this);
		this.toggle5 = this.toggle5.bind(this);
	}
	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen: newArray
		});
	}
	toggle1(i) {
		const newArray = this.state.dropdownOpen1.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen1: newArray
		});
	}
	toggle2(i) {
		const newArray = this.state.dropdownOpen2.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen2: newArray
		});
	}
	toggle3(i) {
		const newArray = this.state.dropdownOpen3.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen3: newArray
		});
	}
	toggle4(i) {
		const newArray = this.state.dropdownOpen4.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen4: newArray
		});
	}
	toggle5(i) {
		const newArray = this.state.dropdownOpen5.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen5: newArray
		});
	}
	
  render() {
	
	let userData = JSON.parse(sessionStorage.getItem('userData'));
    this.state.userRole = userData['userrole'];
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-home"></i>&nbsp; Academic</a>
		  {/*<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>*/}
		  <div className="" >
			<ul className="navbar-nav mr-auto">
			{(this.state.userRole == 'markentry' || this.state.userRole == 'classteacher') ? '' :
			<React.Fragment>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
				<DropdownToggle caret color="class">
					  Class & Section
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/academic/class/addsection" className="dropdown-item" >Section</Link>
						<Link to="/academic/class/classteacherallocate" className="dropdown-item">Class Teacher Allocation</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen1[0]} toggle={() => { this.toggle1(0); }}>
				<DropdownToggle caret color="subject">
					Subjects
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/academic/subject/subject" className="dropdown-item" >Subject</Link>
						<Link to="/academic/subject/assignsubject" className="dropdown-item">Assign Subject</Link>
						<Link to="/academic/subject/subjectallocate" className="dropdown-item">Subject Allocate</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen2[0]} toggle={() => { this.toggle2(0); }}>
				<DropdownToggle caret color="timetable">
					Time Table
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/academic/timetable/create" className="dropdown-item" >Create Timetable</Link>
						<Link to="/academic/timetable/print" className="dropdown-item">Print Timetable</Link>
						<Link to="/academic/timetable/summary" className="dropdown-item">Summary</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			</React.Fragment> }
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen3[0]} toggle={() => { this.toggle3(0); }}>
				<DropdownToggle caret color="exam">
					Exams
				</DropdownToggle>
					{this.state.userRole == 'markentry' ? 
						<DropdownMenu>
							<Link to="/academic/exams/markentry" className="dropdown-item" >Enter Marks By Subject</Link>
							<Link to="/academic/exams/markentrystud" className="dropdown-item" >Enter Marks By Student</Link>
						</DropdownMenu>
					:
					this.state.userRole == 'classteacher' ? 
						<DropdownMenu>
							<Link to="/academic/exams/markentry" className="dropdown-item" >Enter Marks By Subject</Link>
							<Link to="/academic/exams/markentrystud" className="dropdown-item" >Enter Marks By Student</Link>
							<Link to="/academic/exams/observation" className="dropdown-item" >Class Teacher Observation </Link>
							<Link to="/academic/exams/reportcard" className="dropdown-item" >Report Card</Link>
							<Link to="/academic/exams/analysisreport" className="dropdown-item" >Analysis Report</Link>
							<Link to="/academic/exams/ranklist" className="dropdown-item" >Rank List</Link>
						</DropdownMenu>
					:
						<DropdownMenu>
							<Link to="/academic/exams/setexam" className="dropdown-item" >Create Exam</Link>
							<Link to="/academic/exams/exam" className="dropdown-item" >Exam Time Table</Link>
							<Link to="/academic/exams/markentry" className="dropdown-item" >Enter Marks By Subject</Link>
							<Link to="/academic/exams/markentrystud" className="dropdown-item" >Enter Marks By Student</Link>
							<Link to="/academic/exams/observation" className="dropdown-item" >Class Teacher Observation </Link>
							<Link to="/academic/exams/reportcard" className="dropdown-item" >Report Card</Link>
							<Link to="/academic/exams/analysisreport" className="dropdown-item" >Analysis Report</Link>
							<Link to="/academic/exams/ranklist" className="dropdown-item" >Rank List</Link>
							<Link to="/academic/exams/grade" className="dropdown-item" >Set Grade</Link>
						</DropdownMenu>
					}
				</ButtonDropdown>
			  </li>
			  {(this.state.userRole == 'markentry' || this.state.userRole == 'classteacher') ? '' :
			<React.Fragment>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen4[0]} toggle={() => { this.toggle4(0); }}>
				<DropdownToggle caret color="Assignment">
					Assignment & Notes
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/academic/assignment/add" className="dropdown-item" >Assignment</Link>
						<Link to="/academic/assignment/addnotes" className="dropdown-item" >Notes</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen5[0]} toggle={() => { this.toggle5(0); }}>
				<DropdownToggle caret color="Certificate">
					Certificate
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/academic/certificate/transfer" className="dropdown-item" >Transfer Certificate</Link>
						<Link to="/academic/certificate/bonafide" className="dropdown-item" >Bonafide Certificate</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item active">
				<Link to="/academic/occurrence/register" className="nav-link" >Occurrence</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/academic/circular/add" className="nav-link" >Circular</Link>
			  </li>
			  </React.Fragment> }
			</ul>
		  </div>
		</nav>
    )
  }
}

export default AcademicPage;


// WEBPACK FOOTER //
// ./src/views/AcademicPage/AcademicPage.js